
import styled  from 'styled-components';

export const CoursesWrapper = styled.div<{isMobile: boolean}>`
   display: flex;
   overflow-x: scroll;
   padding-bottom: 2px;
`;